<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bbm-page"
  *ngIf="!contentReady"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar">
            <i
              class="fa-solid fa-boxes-stacked"
              aria-hidden="true"
            ></i>
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'bundlesmobile.management.section' | transloco }}
            </span>

            <h2>
              {{ 'bundlesmobile.management.title' | transloco }}
            </h2>

            <p>
              {{ 'bundlesmobile.management.subtitle' | transloco }}
            </p>
          </div>

        </div>

      </div>

      <div class="bbm-actions-grid bbm-hero-actions noPrint">
        <button
          type="button"
          routerLink="/addbundle"
          class="bbm-action-btn bbm-action-primary bbm-action-wide"
        >
          <i
            class="fa-solid fa-plus"
            aria-hidden="true"
          ></i>

          <span>
            {{ 'bundlesmobile.management.addBundle' | transloco }}
          </span>
        </button>
      </div>

    </section>

    <!-- STATS -->
    <section class="bbm-details-grid bbm-summary-grid bbm-section">

      <div class="bbm-detail-chip bbm-detail-primary bbm-detail-wide">
        <i
          class="fa-solid fa-layer-group"
          aria-hidden="true"
        ></i>

        <span>
          {{ 'bundlesmobile.management.totalBundles' | transloco }}
        </span>

        <strong>
          {{ totalBundles }}
        </strong>
      </div>

      <div class="bbm-detail-chip bbm-detail-success">
        <i
          class="fa-solid fa-arrow-trend-down"
          aria-hidden="true"
        ></i>

        <span>
          {{ 'bundlesmobile.management.lowestPrice' | transloco }}
        </span>

        <strong class="bbm-money-value">
          {{ lowestPrice | number:'1.0-0' }}

          <small>
            {{ 'bundlesmobile.management.egp' | transloco }}
          </small>
        </strong>
      </div>

      <div class="bbm-detail-chip bbm-detail-danger">
        <i
          class="fa-solid fa-arrow-trend-up"
          aria-hidden="true"
        ></i>

        <span>
          {{ 'bundlesmobile.management.highestPrice' | transloco }}
        </span>

        <strong class="bbm-money-value">
          {{ highestPrice | number:'1.0-0' }}

          <small>
            {{ 'bundlesmobile.management.egp' | transloco }}
          </small>
        </strong>
      </div>

    </section>

    <!-- SEARCH -->
    <section class="bbm-form-ticket">

      <div class="bbm-search-row">

        <div class="bbm-search-control">
          <i
            class="fa-solid fa-magnifying-glass"
            aria-hidden="true"
          ></i>

          <input
            type="text"
            class="bbm-control"
            [value]="searchTerm"
            (keyup)="applyFilter($event)"
            [placeholder]="
              'bundlesmobile.management.searchPlaceholder'
                | transloco
            "
          />
        </div>

        <button
          *ngIf="searchTerm"
          type="button"
          class="
            bbm-action-btn
            bbm-action-danger
            bbm-action-compact
          "
          (click)="clearSearch()"
          [attr.aria-label]="
            'bundlesmobile.management.clearSearch'
              | transloco
          "
        >
          <i
            class="fa-solid fa-xmark"
            aria-hidden="true"
          ></i>

          <span>
            {{ 'bundlesmobile.management.clearSearch' | transloco }}
          </span>
        </button>

      </div>

    </section>

    <!-- BUNDLE CARDS -->
    <section
      class="bbm-ticket-list"
      *ngIf="filteredBundles.length > 0; else emptyState"
    >
      <article
        class="bbm-ticket"
        *ngFor="
          let el of filteredBundles;
          trackBy: trackByBundle
        "
      >

        <!-- BUNDLE TOP -->
        <div class="bbm-ticket-top">

          <div class="bbm-main-info">

            <div class="bbm-avatar bbm-avatar-contain">
              <img
                [src]="fixImage(el.image)"
                (error)="onImageError($event)"
                [alt]="
                  'bundlesmobile.management.bundleImage'
                    | transloco
                "
              />
            </div>

            <div class="bbm-copy">
              <span>
                {{ 'bundlesmobile.management.section' | transloco }}
              </span>

              <h3>
                {{
                  isAr
                    ? (el.name_ar || el.name_en || '—')
                    : (el.name_en || el.name_ar || '—')
                }}
              </h3>

              <p>
                {{
                  isAr
                    ? (el.name_en || '—')
                    : (el.name_ar || '—')
                }}
              </p>
            </div>

          </div>

        </div>

        <!-- COMPONENTS -->
        <div class="bbm-products-block">

          <div class="bbm-block-head">
            <span>
              {{ 'bundlesmobile.management.components' | transloco }}
            </span>
          </div>

          <div
            class="bbm-badges-row"
            *ngIf="el.items?.length; else noItems"
          >
            <span
              class="bbm-badge bbm-badge-dark"
              *ngFor="let item of el.items"
            >
              <span>
                {{
                  isAr
                    ? item.stock?.name_ar
                    : item.stock?.name_en
                }}
              </span>

              <strong>
                x{{ item.quantity }}
              </strong>
            </span>
          </div>

          <ng-template #noItems>
            <span class="bbm-badge bbm-badge-warning">
              <i
                class="fa-solid fa-circle-exclamation"
                aria-hidden="true"
              ></i>

              {{ 'bundlesmobile.management.noItems' | transloco }}
            </span>
          </ng-template>

        </div>

        <!-- PRICES -->
        <div
          class="
            bbm-details-grid
            bbm-summary-grid
            bbm-ticket-section
          "
        >

          <!-- MAIN PRICE -->
          <div
            class="
              bbm-detail-chip
              bbm-detail-success
              bbm-detail-wide
            "
          >
            <i
              class="fa-solid fa-money-bill-wave"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'bundlesmobile.management.mainPrice' | transloco }}
            </span>

            <strong class="bbm-money-value">
              {{ el.price | number:'1.0-0' }}

              <small>
                {{ 'bundlesmobile.management.egp' | transloco }}
              </small>
            </strong>
          </div>

          <!-- AFFILIATION PRICE -->
          <div class="bbm-detail-chip bbm-detail-primary">
            <i
              class="fa-solid fa-handshake"
              aria-hidden="true"
            ></i>

            <span>
              {{
                'bundlesmobile.management.affiliationPrice'
                  | transloco
              }}
            </span>

            <strong class="bbm-money-value">
              {{ el.affiliationprice | number:'1.0-0' }}

              <small>
                {{ 'bundlesmobile.management.egp' | transloco }}
              </small>
            </strong>
          </div>

          <!-- PRICE A -->
          <div class="bbm-detail-chip">
            <i
              class="fa-solid fa-a"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'bundlesmobile.management.pageA' | transloco }}
            </span>

            <strong class="bbm-money-value">
              {{ el.pricea | number:'1.0-0' }}

              <small>
                {{ 'bundlesmobile.management.egp' | transloco }}
              </small>
            </strong>
          </div>

          <!-- PRICE B -->
          <div class="bbm-detail-chip">
            <i
              class="fa-solid fa-b"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'bundlesmobile.management.pageB' | transloco }}
            </span>

            <strong class="bbm-money-value">
              {{ el.priceb | number:'1.0-0' }}

              <small>
                {{ 'bundlesmobile.management.egp' | transloco }}
              </small>
            </strong>
          </div>

          <!-- PRICE C -->
          <div class="bbm-detail-chip">
            <i
              class="fa-solid fa-c"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'bundlesmobile.management.pageC' | transloco }}
            </span>

            <strong class="bbm-money-value">
              {{ el.pricec | number:'1.0-0' }}

              <small>
                {{ 'bundlesmobile.management.egp' | transloco }}
              </small>
            </strong>
          </div>

        </div>

        <!-- ACTIONS -->
        <div class="bbm-actions-grid bbm-ticket-section">

          <button
            type="button"
            class="bbm-action-btn bbm-action-warning"
            (click)="edit(el)"
          >
            <i
              class="fa-regular fa-pen-to-square"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'bundlesmobile.management.edit' | transloco }}
            </span>
          </button>

          <button
            type="button"
            class="bbm-action-btn bbm-action-danger"
            (click)="delete(el.id)"
          >
            <i
              class="fa-regular fa-trash-can"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'bundlesmobile.management.delete' | transloco }}
            </span>
          </button>

        </div>

      </article>
    </section>

    <!-- EMPTY STATE -->
    <ng-template #emptyState>
      <div class="bbm-empty-state">

        <app-nodata
          *ngIf="noData && !searchTerm"
        ></app-nodata>

        <i
          *ngIf="searchTerm"
          class="fa-solid fa-magnifying-glass"
          aria-hidden="true"
        ></i>

        <p>
          {{
            searchTerm
              ? (
                  'bundlesmobile.management.noSearchResults'
                    | transloco
                )
              : (
                  'bundlesmobile.management.noBundles'
                    | transloco
                )
          }}
        </p>

      </div>
    </ng-template>

    <!-- LOADING MORE -->
    <div
      class="bbm-loader"
      *ngIf="isLoadingMore"
    >
      <span
        class="bbm-loader-spinner"
        aria-hidden="true"
      ></span>

      <span>
        {{ 'bundlesmobile.management.loadingMore' | transloco }}
      </span>
    </div>

    <!-- END STATE -->
    <div
      class="bbm-end-state"
      *ngIf="
        !isLoadingMore &&
        noMoreData &&
        bundles.length > 0
      "
    >
      {{ 'bundlesmobile.management.allLoaded' | transloco }}
    </div>

  </div>
</section>